export const LGA: string[] = [
  "Alpine Shire council",
  "Ararat Rural City council",
  "Ballarat City council",
  "Banyule City council",
  "Bass Coast Shire council",
  "Baw Baw Shire council",
  "Bayside City council",
  "Benalla Rural City council",
  "Boroondara City council",
  "Brimbank City council",
  "Buloke Shire council",
  "Campaspe Shire council",
  "Cardinia Shire council",
  "Casey City council",
  "Central Goldfields Shire council",
  "Colac Otway Shire council",
  "Corangamite Shire council",
  "Darebin City council",
  "East Gippsland Shire council",
  "Frankston City council",
  "Gannawarra Shire council",
  "Glen Eira City council",
  "Glenelg Shire council",
  "Golden Plains Shire council",
  "Greater Bendigo City council",
  "Greater Dandenong City council",
  "Greater Geelong City council",
  "Greater Shepparton City council",
  "Hepburn Shire council",
  "Hindmarsh Shire council",
  "Hobsons Bay City council",
  "Horsham Rural City council",
  "Hume City council",
  "Indigo Shire council",
  "Kingston City council",
  "Knox City council",
  "Latrobe City council",
  "Loddon Shire council",
  "Macedon Ranges Shire council",
  "Manningham City council",
  "Mansfield Shire council",
  "Maribyrnong City council",
  "Maroondah City council",
  "Melbourne City council",
  "Melton City council",
  "Merri-Bek City council",
  "Mildura Rural City council",
  "Mitchell Shire council",
  "Moira Shire council",
  "Monash City council",
  "Moonee Valley City council",
  "Moorabool Shire council",
  "Mornington Peninsula Shire council",
  "Mount Alexander Shire council",
  "Moyne Shire council",
  "Murrindindi Shire council",
  "Nillumbik Shire council",
  "Northern Grampians Shire council",
  "Port Phillip City council",
  "Pyrenees Shire council",
  "Queenscliffe Borough council",
  "South Gippsland Shire council",
  "Southern Grampians Shire council",
  "Stonnington City council",
  "Strathbogie Shire council",
  "Surf Coast Shire council",
  "Swan Hill Rural City council",
  "Towong Shire council",
  "Wangaratta Rural City council",
  "Warrnambool City council",
  "Wellington Shire council",
  "West Wimmera Shire council",
  "Whitehorse City council",
  "Whittlesea City council",
  "Wodonga City council",
  "Wyndham City council",
  "Yarra City council",
  "Yarra Ranges Shire council",
  "Yarriambiack Shire council",
];
